import React from "react";
import OnboardingStep from "./OnboardingStep";

const Step3PlayAndClimb: React.FC = () => {
  return (
    <OnboardingStep
      className="step3-play-and-climb"
      title="Step 3: Play & Climb"
      description="Play pool, log your wins, and climb the leaderboards!"
    />
  );
};

export default Step3PlayAndClimb;
